module.exports = __webpack_public_path__ + "static/media/mechanical-eng.46c236fc.jpg";